import Login from './Login/Login';
import Register from './Register/Register';
import ResetPassword from './ResetPassword/ResetPassword';
import SetPassword from './SetPassword/SetPassword';

function Auth({ type }) {
  if (type === 'setPassword') return <SetPassword />;
  if (type === 'resetPassword') return <ResetPassword />;
  if (type === 'register') return <Register />;

  return <Login />;
}

export default Auth;
